(() => {
  const CARD_ADDON_VARIANT_ID = 50963040862506;
  const GIFT_ID_PROPERTY = '_JF Gift ID';
  let running = false;

  const paidCard = (item) => {
    const card = ((item.properties || {})['Card'] || '').toString().trim();
    return card && card.toLowerCase() !== 'no card' ? card : '';
  };

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Unable to load cart');
    return res.json();
  }

  async function addAddon(cardType, cardMessage, giftId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: CARD_ADDON_VARIANT_ID,
          quantity: 1,
          properties: {
            'Card Type': cardType || '',
            'Card Message': cardMessage || '',
            [GIFT_ID_PROPERTY]: giftId || ''
          }
        }]
      })
    });
    if (!res.ok) throw new Error('Unable to add card add-on');
  }

  async function removeLine(line) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: 0 })
    });
    if (!res.ok) throw new Error('Unable to remove card add-on');
  }

  async function reconcile() {
    if (running || !window.location.pathname.startsWith('/cart')) return;
    running = true;
    try {
      const cart = await getCart();
      const hosts = cart.items.filter((item) => item.variant_id !== CARD_ADDON_VARIANT_ID && paidCard(item));
      const addons = cart.items.map((item, index) => ({ item, line: index + 1 })).filter(({ item }) => item.variant_id === CARD_ADDON_VARIANT_ID);
      const tokenizedHosts = hosts.filter((item) => ((item.properties || {})[GIFT_ID_PROPERTY] || '').toString().trim());
      const hostTokens = new Set(tokenizedHosts.map((item) => (item.properties || {})[GIFT_ID_PROPERTY].toString().trim()));
      const addonTokens = new Set(addons.map(({ item }) => ((item.properties || {})[GIFT_ID_PROPERTY] || '').toString().trim()).filter(Boolean));

      for (const host of tokenizedHosts) {
        const props = host.properties || {};
        const giftId = (props[GIFT_ID_PROPERTY] || '').toString().trim();
        if (!addonTokens.has(giftId)) {
          await addAddon(paidCard(host), (props['Card Message'] || '').toString().trim(), giftId);
          window.location.reload();
          return;
        }
      }

      for (let i = addons.length - 1; i >= 0; i -= 1) {
        const { item, line } = addons[i];
        const giftId = ((item.properties || {})[GIFT_ID_PROPERTY] || '').toString().trim();
        if (giftId && !hostTokens.has(giftId)) {
          await removeLine(line);
          window.location.reload();
          return;
        }
      }

      const legacyHosts = hosts.filter((item) => !((item.properties || {})[GIFT_ID_PROPERTY] || '').toString().trim());
      const legacyAddons = addons.filter(({ item }) => !((item.properties || {})[GIFT_ID_PROPERTY] || '').toString().trim());
      if (legacyHosts.length > 0 && legacyAddons.length === 0) {
        const host = legacyHosts[0];
        const props = host.properties || {};
        await addAddon(paidCard(host), (props['Card Message'] || '').toString().trim(), '');
        window.location.reload();
        return;
      }
      if (legacyHosts.length === 0 && legacyAddons.length > 0) {
        await removeLine(legacyAddons[0].line);
        window.location.reload();
      }
    } catch (error) {
      console.error('JF card add-on cart reconciliation error:', error);
    } finally {
      running = false;
    }
  }

  reconcile();
  const hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'cart-items') window.setTimeout(reconcile, 150);
    });
  }
})();